import { render } from "./circles.vue?vue&type=template&id=2a6ff2a8&scoped=true"
import script from "./circles.vue?vue&type=script&lang=js"
export * from "./circles.vue?vue&type=script&lang=js"

import "./circles.vue?vue&type=style&index=0&id=2a6ff2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6ff2a8"]])

export default __exports__